import { FiltersProvider } from "domain/Filters";
import { CensusProvider } from "..";

export const CensusListProvider = ({ children }) => (
  <FiltersProvider>
    <CensusProvider>{children}</CensusProvider>
  </FiltersProvider>
);
